import { render, staticRenderFns } from "./backreports.vue?vue&type=template&id=3953c13c&scoped=true&"
import script from "./backreports.vue?vue&type=script&lang=js&"
export * from "./backreports.vue?vue&type=script&lang=js&"
import style0 from "./backreports.vue?vue&type=style&index=0&id=3953c13c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3953c13c",
  null
  
)

export default component.exports